export default {
  contact_provider: 'Bitte wende dich an deinen Anbieter, um diese Funktion einzuschalten.',
};
